module.exports = __webpack_public_path__ + "f70c7f79de3ad41778e4559844553071.jpg";